import {EventEmitter} from 'events';

class GDSdk extends EventEmitter{
   

    raiseGamePause=()=>{
      this.emit('game-pause');  
    }

    raiseGameStart=()=>{
      this.emit('game-start')
    }
    raiseAdError=()=>{
      this.emit('ad-error');
    }
    raiseShowAdSuccess=()=>{
      this.emit('show-ad-success');
    }

    onGamePause(gamePauseHandler){
      this.on('game-pause',gamePauseHandler);      
    } 
    onGameStart(gameStartHandler){
      this.on('game-start',gameStartHandler);      
    }
    onAdError(adErrorHandler){
      this.on('ad-error',adErrorHandler);
    }
    onShowAdSuccess(showAdSuccessHandler){
      this.on('show-ad-success',showAdSuccessHandler);
    }

    onceGamePause(gamePauseHandler){
      this.once('game-pause',gamePauseHandler);      
    } 
    onceGameStart(gameStartHandler){
      this.once('game-start',gameStartHandler);      
    }
    onceAdError(adErrorHandler){
      this.once('ad-error',adErrorHandler);
    }
    onceShowAdSuccess(showAdSuccessHandler){
      this.once('show-ad-success',showAdSuccessHandler);
    }

    removeGamePauseListener(gamePauseHandler){
      this.removeListener('game-pause',gamePauseHandler);
    }
    removeGameStartListener(gameStartHandler){
      this.removeListener('game-start',gameStartHandler);
    }
    removeAdErrorListener(adErrorHandler){
      this.removeListener('ad-error',adErrorHandler);
    }
    removeShowAdSuccessListener(showAdSuccessHandler){
      this.removeListener('show-ad-success',showAdSuccessHandler);
    }


    load = () => {
        return new Promise((resolve, reject) => {
          window["GD_OPTIONS"] = {
            gameId: "7b5681d931ae4067affc7285df33d67b",
            onEvent:  (event)=> {
              //console.log('gdsdk event',event);
              switch (event.name) {
                case "AD_ERROR":
                  console.log('ADD-ERROR',event);
                    this.raiseAdError();                  
                  break;
                case "SDK_GAME_START":
                  // advertisement done, resume game logic and unmute audio
              
                  //console.log('SDK game start called',this.onGameStart);
                  this.raiseGameStart();
                  
                  break;
                case "SDK_GAME_PAUSE":
                  // pause game logic / mute audio
                  this.raiseGamePause();
                  break;
                case "SDK_GDPR_TRACKING":
                  // this event is triggered when your user doesn't want to be tracked
                  break;
                case "SDK_GDPR_TARGETING":
                  // this event is triggered when your user doesn't want personalised targeting of ads and such
                  break;
                case "SDK_READY":
                    //console.log('puzzle sdk is ready');
                    resolve();
                  break;                  
                  
                default:
                    break;
              }
            },
          };
          (function (d, s, id) {
            var js,
              fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s);
            js.id = id;
            js.src = "https://html5.api.gamedistribution.com/main.min.js";

            js.addEventListener('load',()=>{
                //console.log('puzzle GD Sdk loaded');
                //resolve();
            });

            fjs.parentNode.insertBefore(js, fjs);
          })(document, "script", "gamedistribution-jssdk");
        });
      };

      showAd = ()=>{
          return new Promise((resolve,reject)=>{
            setTimeout(async ()=>{
              try{
                await this.showAdCore();
                console.log('success show ad');
                resolve();
              }catch(e){
                console.log('error',e);
                reject();
              }               
            },2000);
          });
      };

      showAdCore = (rewarded)=>{

            return new Promise(async(resolve,reject)=>{

              const rejectOnError = (error)=>{
                reject(error);
              };

              try{
                //console.log('in puzzle show ad');

                if(!window.gdsdk) reject(new Error('gd sdk not initialized'));

                                
                this.onceAdError(rejectOnError);

                if(rewarded){
                  await window.gdsdk.showAd('rewarded');
                }else{
                  await window.gdsdk.showAd();
                }
                
                //console.log('puzzle show ad success');
               
                resolve();
              
              }catch(e){
                console.log('puzzl show ad failure',e);
                reject(e);
              }finally{
                this.removeListener('ad-error',rejectOnError);
              }

            });

            
            
      };
}

export const gdSdk = new GDSdk(); 
